import {
    Component,
    ElementRef,
    Input,
    SimpleChanges,
    AfterViewChecked,
    Renderer2,
    OnDestroy
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import 'rxjs/add/operator/takeWhile';

import {TabComponentBase} from 'app/buffer-graph/models/tab-component-base';
import {StateInfo} from 'app/buffer-graph/models/assortment-structure/state-info';
import {BalanceStructure} from 'app/buffer-graph/models/assortment-structure/balance-structure';
import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
// import am4lang_ru_RU from "@amcharts/amcharts4/lang/ru_RU"
// import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column';
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ExcelWorkService} from "../../../services/excel-work.service";

@Component({
    selector: 'assortment-structure',
    templateUrl: './assortment-structure.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', './assortment-structure.component.css']
})
export class AssortmentStructureComponent extends TabComponentBase<any, any> implements AfterViewChecked, OnDestroy{
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef
    ){
        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);

        this.translates = {};
        this.translateService.get(['ActivitiesByNetwork', 'BalanceStructure', 'BalanceEqualZero', 'BalanceInSaftey', 'BalanceInRed', 'BalanceInYellow', 'BalanceInGreen', 'BalanceInOverstock']).subscribe(t =>{
            for (const key in t)
                if (t.hasOwnProperty(key))
                    this.translates[key] = t[key];
            this.translatesLoaded = true;
        });
    }

    // @ViewChild('state')
    // private stateRef: ElementRef;
    //
    // @ViewChild('balance')
    // private balanceRef: ElementRef;

    @Input()
    public isActive: boolean;

    @Input()
    private states: StateInfo[];

    @Input()
    private balanceStructure: BalanceStructure;

    @Input()
    private statesChartId: string;

    @Input()
    private balanceChartId: string;

    private readonly translates: { [key: string]: string };

    // public readonly chartHeightCoefficient = 2.0 / 3.0;

    protected gridRef: SlickGridComponent;

    // protected sku: string;

    // protected warehouseCode: string;

    public canSend: boolean;

    private statesChart: am4charts.PieChart3D;

    private createStatesChartAfterViewChecked: boolean;

    // private statesDrawer: IntervalObservable;

    private balanceChart: am4charts.PieChart3D;

    private createBalanceChartAfterViewChecked: boolean;

    // private balanceDrawer: IntervalObservable;

    private translatesLoaded: boolean;

    protected getExportData = this.getExportDataByDefault;

    ngOnChanges(changes: SimpleChanges): void{
        super.ngOnChanges(changes);

        if ((changes['states'] || changes['statesChartId']) && this.states && this.statesChartId /* && !this.statesDrawer*/)
            this.createStatesChartAfterViewChecked = true;

        if ((changes['balanceStructure'] || changes['balanceChartId']) && this.balanceStructure && this.balanceChartId /* && !this.statesDrawer*/)
            this.createBalanceChartAfterViewChecked = true;
    }

    ngOnDestroy(){
        if (this.statesChart){
            this.statesChart.dispose();
            this.statesChart = null;
        }

        if (this.balanceChart){
            this.balanceChart.dispose();
            this.balanceChart = null;
        }

    }

    ngAfterViewChecked(): void{
        if (this.createStatesChartAfterViewChecked){
            this.createStatesChartAfterViewChecked = false;
            this.createStatesChart();
        }

        if (this.createBalanceChartAfterViewChecked){
            this.createBalanceChartAfterViewChecked = false;
            this.createBalanceChart();
        }

        if (this.resizeChartsLegendsView){
            this.resizeChartsLegendsView = false;
            this.resizeChartsLegends();
        }
    }


    //# resize chart legends
    protected onTabsResized(): boolean{
        if (!super.onTabsResized(this.sharedGUID))
            return false;

        /*setTimeout(() => {
                if (this.statesChart) {
                    this.setStatesChartSize();
                    this.statesChart.draw();
                }

                if (this.balanceChart) {
                    this.setBalanceChartSize();
                    this.balanceChart.draw();
                }
            },
            1);*/

        return true;
    }



    //# Generate state chart
    private createStatesChart = (): void =>{

        am4core.useTheme(am4themes_animated);


        this.statesChart = am4core.create("chart-1", am4charts.PieChart3D);
        this.statesChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        this.statesChart.legend = new am4charts.Legend();

        this.states.forEach(item => item.color = am4core.color(item.getColor()));

        this.statesChart.data = this.states;

        let series = this.statesChart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "count";
        series.dataFields.category = "state";
        series.slices.template.propertyFields.fill = "color";
        series.labels.template.disabled = true;

        this.createChartLegend(this.statesChart, 'chart-1-legend');
        // this.statesChart.events.on("appeared", this.resizeLegendST);
        this.statesChart.events.on("sizechanged", this.resizeLegendST);
        this.statesChart.legend.events.on("sizechanged", this.resizeLegendST);
    }

    //# Generate balance chart
    private createBalanceChart = (): void =>{

        const data: { count: number, color: any, state: string }[] = [];

        for (const prop in this.balanceStructure){
            if (!this.balanceStructure.hasOwnProperty(prop) || this.balanceStructure[prop] === 0)
                continue;

            switch (prop){
                case 'zeroBalance':
                    data.push({
                        state: this.translates['BalanceEqualZero'],
                        count: this.balanceStructure.zeroBalance,
                        color: am4core.color('#000000')
                    });
                    break;
                case 'safetyStockZone':
                    data.push({
                        state: this.translates['BalanceInSaftey'],
                        count: this.balanceStructure.safetyStockZone,
                        color: am4core.color('#800000')
                    });
                    break;
                case 'redZone':
                    data.push({
                        state: this.translates['BalanceInRed'],
                        count: this.balanceStructure.redZone,
                        color: am4core.color('#FF0000')
                    });
                    break;
                case 'yellowZone':
                    data.push({
                        state: this.translates['BalanceInYellow'],
                        count: this.balanceStructure.yellowZone,
                        color: am4core.color('#FFFF00')
                    });
                    break;
                case 'greenZone':
                    data.push({
                        state: this.translates['BalanceInGreen'],
                        count: this.balanceStructure.greenZone,
                        color: am4core.color('#32CD32')
                    });
                    break;
                case 'overstockZone':
                    data.push({
                        state: this.translates['BalanceInOverstock'],
                        count: this.balanceStructure.overstockZone,
                        color: am4core.color('#0000FF')
                    });
                    break;
            }
        }

        am4core.useTheme(am4themes_animated);

        this.balanceChart = am4core.create("chart-2", am4charts.PieChart3D);
        this.balanceChart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        this.balanceChart.legend = new am4charts.Legend();

        this.balanceChart.data = data;

        let series = this.balanceChart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "count";
        series.dataFields.category = "state";
        series.slices.template.propertyFields.fill = "color";
        series.labels.template.disabled = true;

        this.createChartLegend(this.balanceChart, 'chart-2-legend');
        this.balanceChart.events.on("sizechanged", this.resizeLegendBC);
        this.balanceChart.legend.events.on("sizechanged", this.resizeLegendBC);
    }

    //# create chart for legend
    private createChartLegend = (chart: am4charts.PieChart3D, id: string): void => {
        let legendContainer = am4core.create(id, am4core.Container);
        legendContainer.width = am4core.percent(100);
        legendContainer.height = am4core.percent(100);
        chart.legend.parent = legendContainer;

    }

    private resizeLegendST = (): void => {
        // if (this.tab.displayMode){
        //     return;
        // }
        document.getElementById('chart-1-legend').style.height = this.statesChart.legend.contentHeight + "px";

    };

    private resizeLegendBC = (): void => {
        // if (this.tab.displayMode){
        //     return;
        // }
        document.getElementById('chart-2-legend').style.height = this.balanceChart.legend.contentHeight + "px";
    };

    protected resizeChartsLegends = (): void => {
        this.resizeLegendST();
        this.resizeLegendBC();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/assortment-structure.component/assortment-structure.component.ts